@if (useMobileLayout$ | async) {
  <ion-header slot="top">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button></ion-back-button>
      </ion-buttons>
      <ion-title class="tw:relative tw:h-10 tw:p-0.5">
        <img alt="Application Logo" class="tw:object-contain" ngSrc="{{ logoUrl }}" fill />
      </ion-title>
    </ion-toolbar>
    <ng-content></ng-content>
  </ion-header>
}
